import { useCallback, useLayoutEffect, useState } from 'react';
import { useTranslation } from '@hotjar/translations';
import type { Site } from '@hotjar/site';
import { useToggleFeedbackWidgetStatusMutation } from '../../../../domain/IncomingFeedback/query';
import { ActivationSwitch } from '../../../common/ActivationSwitch/ActivationSwitch';

export const FeedbackActivationSwitch = ({
  isEnabledInitalState,
  site,
  feedbackWidgetId,
  hasPermission,
}: {
  site: Site;
  feedbackWidgetId: number;
  hasPermission: boolean;
  isEnabledInitalState: boolean;
}): JSX.Element => {
  const [isEnabled, setEnabled] = useState<boolean>(isEnabledInitalState);
  const { t } = useTranslation('feedback');

  useLayoutEffect(() => {
    setEnabled(isEnabledInitalState);
  }, [isEnabledInitalState]);

  const toggleFeedbackWidgetStatusMutation = useToggleFeedbackWidgetStatusMutation();

  const onToggle = useCallback(() => {
    if (!hasPermission) return;

    setEnabled((wasEnabled) => {
      toggleFeedbackWidgetStatusMutation
        .mutateAsync({ site, feedbackWidgetId })
        .catch(() => setEnabled(wasEnabled));
      return !wasEnabled;
    });
  }, [hasPermission, site, feedbackWidgetId, toggleFeedbackWidgetStatusMutation]);

  return (
    <ActivationSwitch
      name={t('feedback-responses.header.status')}
      isEnabled={isEnabled}
      onToggle={onToggle}
      hasPermission={hasPermission}
    />
  );
};
